import { Navigate, Routes, Route } from 'react-router-dom';
import { EventDetail } from './pages/EventDetail';
import { Events } from './pages/Events';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { Login } from './pages/Login';
import { Send } from './pages/Send';
import { Tenants } from './pages/Tenants';
import { TenantDetail } from './pages/TenantDetail';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/login" />} />
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/tenants" element={<Tenants />} />
        <Route path="/tenants/:slug" element={<TenantDetail />} />
        <Route path="/send" element={<Send />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/:messageId" element={<EventDetail />} />
      </Route>
    </Routes>
  );
}
